import { GameModality } from './game'

// Amenidades/Facilidades da arena
export enum ArenaAmenity {
  PARKING = 'parking',
  LOCKER_ROOM = 'locker_room',
  SHOWER = 'shower',
  BATHROOM = 'bathroom',
  BAR = 'bar',
  RESTAURANT = 'restaurant',
  BBQ = 'bbq',
  WIFI = 'wifi',
  STORE = 'store',
  LIGHTING = 'lighting',
  AIR_CONDITIONING = 'air_conditioning',
  BLEACHERS = 'bleachers'
}

// Tipo de quadra/campo
export interface Court {
  id: string
  name: string
  photo?: string
  modalities: GameModality[]
  amenities?: ArenaAmenity[]
}

// Arena interface
export interface Arena {
  id: string
  slug?: string
  name: string
  logo?: string
  coverImage: string
  photos?: string[]
  modalities: GameModality[]
  location: string
  distance: number // em metros
  rating?: number
  reviewCount?: number
  address: string
  coordinate?: {
    latitude: number
    longitude: number
  }
  description?: string
  amenities?: ArenaAmenity[]
  courts?: Court[]
  phone?: string
  whatsapp?: string
  website?: string
  openingHours?: string
  socialMedia?: {
    instagram?: string
    facebook?: string
  }
}

// Helper para formatar distância
export function formatDistance(meters: number): string {
  if (meters < 1000) {
    return `${Math.round(meters)}m`
  }
  return `${(meters / 1000).toFixed(1)}km`
}

// Mock data de arenas
export const MOCK_ARENAS: Arena[] = [
  {
    id: '1',
    name: 'Arena Copacabana Beach',
    logo: 'https://images.unsplash.com/photo-1599305445671-ac291c95aaa9?w=200&h=200&fit=crop',
    coverImage: 'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?w=800&h=500&fit=crop',
    photos: [
      'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=600&fit=crop',
      'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=800&h=600&fit=crop'
    ],
    modalities: [GameModality.BEACH_TENNIS, GameModality.VOLLEYBALL],
    location: 'Copacabana, Rio de Janeiro',
    distance: 500,
    rating: 4.8,
    reviewCount: 124,
    address: 'Av. Atlântica, 1500 - Copacabana, Rio de Janeiro - RJ',
    coordinate: {
      latitude: -22.9711,
      longitude: -43.1822
    },
    description: 'A Arena Copacabana Beach é o destino perfeito para os amantes de esportes de praia. Localizada à beira-mar, nossa arena oferece quadras profissionais de beach tennis e vôlei, com areia de primeira qualidade e vista espetacular para o mar. Ideal para jogos casuais ou competições sérias.',
    amenities: [
      ArenaAmenity.PARKING,
      ArenaAmenity.LOCKER_ROOM,
      ArenaAmenity.SHOWER,
      ArenaAmenity.BATHROOM,
      ArenaAmenity.BAR,
      ArenaAmenity.WIFI,
      ArenaAmenity.LIGHTING,
      ArenaAmenity.BLEACHERS
    ],
    courts: [
      {
        id: 'court-1',
        name: 'Quadra 1',
        photo: 'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?w=400&h=300&fit=crop',
        modalities: [GameModality.BEACH_TENNIS],
        amenities: [ArenaAmenity.LIGHTING, ArenaAmenity.BLEACHERS]
      },
      {
        id: 'court-2',
        name: 'Quadra 2',
        photo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
        modalities: [GameModality.BEACH_TENNIS],
        amenities: [ArenaAmenity.LIGHTING]
      },
      {
        id: 'court-3',
        name: 'Quadra Central',
        photo: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=400&h=300&fit=crop',
        modalities: [GameModality.VOLLEYBALL],
        amenities: [ArenaAmenity.LIGHTING, ArenaAmenity.BLEACHERS, ArenaAmenity.WIFI]
      }
    ],
    phone: '(21) 98765-4321',
    whatsapp: '5521987654321',
    website: 'https://arenacopacabana.com.br',
    openingHours: 'Seg-Dom: 6h - 22h',
    socialMedia: {
      instagram: 'https://instagram.com/arenacopacabana',
      facebook: 'https://facebook.com/arenacopacabana'
    }
  },
  {
    id: '2',
    name: 'Club Ipanema Sports',
    coverImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
    modalities: [GameModality.BEACH_TENNIS, GameModality.PADEL, GameModality.TENNIS],
    location: 'Ipanema, Rio de Janeiro',
    distance: 1200,
    rating: 4.9,
    address: 'Rua Visconde de Pirajá, 550 - Ipanema, Rio de Janeiro - RJ',
    coordinate: {
      latitude: -22.9838,
      longitude: -43.2096
    }
  },
  {
    id: '3',
    name: 'Arena Barra da Tijuca',
    coverImage: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=500&fit=crop',
    modalities: [GameModality.FOOTBALL, GameModality.FUTSAL, GameModality.VOLLEYBALL],
    location: 'Barra da Tijuca, Rio de Janeiro',
    distance: 5000,
    rating: 4.7,
    address: 'Av. das Américas, 7777 - Barra da Tijuca, Rio de Janeiro - RJ',
    coordinate: {
      latitude: -23.0025,
      longitude: -43.3647
    }
  },
  {
    id: '4',
    name: 'Quadra Leblon Premium',
    coverImage: 'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=800&h=500&fit=crop',
    modalities: [GameModality.BEACH_TENNIS, GameModality.VOLLEYBALL],
    location: 'Leblon, Rio de Janeiro',
    distance: 800,
    rating: 4.6,
    address: 'Av. Delfim Moreira, 696 - Leblon, Rio de Janeiro - RJ',
    coordinate: {
      latitude: -22.9847,
      longitude: -43.2175
    }
  },
  {
    id: '5',
    name: 'Sport Center Botafogo',
    coverImage: 'https://images.unsplash.com/photo-1519766304817-4f37bda74a26?w=800&h=500&fit=crop',
    modalities: [GameModality.BASKETBALL, GameModality.VOLLEYBALL, GameModality.FUTSAL],
    location: 'Botafogo, Rio de Janeiro',
    distance: 3000,
    rating: 4.5,
    address: 'Rua São Clemente, 155 - Botafogo, Rio de Janeiro - RJ',
    coordinate: {
      latitude: -22.9489,
      longitude: -43.1847
    }
  },
  {
    id: '6',
    name: 'Flamengo Beach Sports',
    coverImage: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=800&h=500&fit=crop',
    modalities: [GameModality.VOLLEYBALL, GameModality.FOOTBALL, GameModality.RUNNING],
    location: 'Flamengo, Rio de Janeiro',
    distance: 2000,
    rating: 4.4,
    address: 'Av. Infante Dom Henrique - Flamengo, Rio de Janeiro - RJ',
    coordinate: {
      latitude: -22.9326,
      longitude: -43.1722
    }
  },
  {
    id: '7',
    name: 'Arena Lagoa Rodrigo de Freitas',
    coverImage: 'https://images.unsplash.com/photo-1594911772125-07fc7a2d8d9f?w=800&h=500&fit=crop',
    modalities: [GameModality.RUNNING, GameModality.VOLLEYBALL, GameModality.BASKETBALL],
    location: 'Lagoa, Rio de Janeiro',
    distance: 1500,
    rating: 4.7,
    address: 'Av. Borges de Medeiros - Lagoa, Rio de Janeiro - RJ',
    coordinate: {
      latitude: -22.9722,
      longitude: -43.2050
    }
  },
  {
    id: '8',
    name: 'Tijuca Tennis Club',
    coverImage: 'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?w=800&h=500&fit=crop',
    modalities: [GameModality.TENNIS, GameModality.PADEL, GameModality.BEACH_TENNIS],
    location: 'Tijuca, Rio de Janeiro',
    distance: 4500,
    rating: 4.8,
    address: 'Rua Conde de Bonfim, 451 - Tijuca, Rio de Janeiro - RJ',
    coordinate: {
      latitude: -22.9192,
      longitude: -43.2315
    }
  },
  {
    id: '9',
    name: 'Arena Zona Sul',
    coverImage: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=500&fit=crop',
    modalities: [GameModality.FUTSAL, GameModality.VOLLEYBALL],
    location: 'Laranjeiras, Rio de Janeiro',
    distance: 2800,
    rating: 4.3,
    address: 'Rua General Glicério, 123 - Laranjeiras, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9321, longitude: -43.1864 }
  },
  {
    id: '10',
    name: 'Complexo Esportivo Méier',
    coverImage: 'https://images.unsplash.com/photo-1519766304817-4f37bda74a26?w=800&h=500&fit=crop',
    modalities: [GameModality.FOOTBALL, GameModality.FUTSAL, GameModality.BASKETBALL],
    location: 'Méier, Rio de Janeiro',
    distance: 6200,
    rating: 4.1,
    address: 'Rua Dias da Cruz, 789 - Méier, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9025, longitude: -43.2782 }
  },
  {
    id: '11',
    name: 'Beach Sports Recreio',
    coverImage: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=800&h=500&fit=crop',
    modalities: [GameModality.BEACH_TENNIS, GameModality.VOLLEYBALL],
    location: 'Recreio dos Bandeirantes, Rio de Janeiro',
    distance: 8500,
    rating: 4.7,
    address: 'Av. Lúcio Costa, 5000 - Recreio, Rio de Janeiro - RJ',
    coordinate: { latitude: -23.0250, longitude: -43.4647 }
  },
  {
    id: '12',
    name: 'Centro Esportivo Gávea',
    coverImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
    modalities: [GameModality.TENNIS, GameModality.PADEL, GameModality.RUNNING],
    location: 'Gávea, Rio de Janeiro',
    distance: 3500,
    rating: 4.6,
    address: 'Rua Marquês de São Vicente, 234 - Gávea, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9794, longitude: -43.2294 }
  },
  {
    id: '13',
    name: 'Arena Maracanã',
    coverImage: 'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=800&h=500&fit=crop',
    modalities: [GameModality.FOOTBALL, GameModality.FUTSAL],
    location: 'Maracanã, Rio de Janeiro',
    distance: 5800,
    rating: 4.4,
    address: 'Av. Presidente Castelo Branco - Maracanã, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9122, longitude: -43.2302 }
  },
  {
    id: '14',
    name: 'Quadras São Conrado',
    coverImage: 'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?w=800&h=500&fit=crop',
    modalities: [GameModality.BEACH_TENNIS, GameModality.TENNIS],
    location: 'São Conrado, Rio de Janeiro',
    distance: 4200,
    rating: 4.8,
    address: 'Estrada da Gávea, 899 - São Conrado, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9978, longitude: -43.2647 }
  },
  {
    id: '15',
    name: 'Sport Club Jacarepaguá',
    coverImage: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=500&fit=crop',
    modalities: [GameModality.FUTSAL, GameModality.VOLLEYBALL, GameModality.BASKETBALL],
    location: 'Jacarepaguá, Rio de Janeiro',
    distance: 7100,
    rating: 4.2,
    address: 'Estrada dos Bandeirantes, 1500 - Jacarepaguá, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9436, longitude: -43.3647 }
  },
  {
    id: '16',
    name: 'Arenas do Leme',
    coverImage: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=800&h=500&fit=crop',
    modalities: [GameModality.BEACH_TENNIS, GameModality.VOLLEYBALL],
    location: 'Leme, Rio de Janeiro',
    distance: 600,
    rating: 4.7,
    address: 'Av. Princesa Isabel, 150 - Leme, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9658, longitude: -43.1736 }
  },
  {
    id: '17',
    name: 'Centro de Treinamento Vila Isabel',
    coverImage: 'https://images.unsplash.com/photo-1519766304817-4f37bda74a26?w=800&h=500&fit=crop',
    modalities: [GameModality.BASKETBALL, GameModality.FUTSAL],
    location: 'Vila Isabel, Rio de Janeiro',
    distance: 5400,
    rating: 4.0,
    address: 'Boulevard 28 de Setembro, 567 - Vila Isabel, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9158, longitude: -43.2494 }
  },
  {
    id: '18',
    name: 'Arena Premium Barra',
    coverImage: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=500&fit=crop',
    modalities: [GameModality.TENNIS, GameModality.PADEL, GameModality.BEACH_TENNIS],
    location: 'Barra da Tijuca, Rio de Janeiro',
    distance: 5200,
    rating: 4.9,
    address: 'Av. Armando Lombardi, 800 - Barra da Tijuca, Rio de Janeiro - RJ',
    coordinate: { latitude: -23.0072, longitude: -43.3111 }
  },
  {
    id: '19',
    name: 'Complexo Santa Teresa',
    coverImage: 'https://images.unsplash.com/photo-1587280501635-68a0e82cd5ff?w=800&h=500&fit=crop',
    modalities: [GameModality.FOOTBALL, GameModality.VOLLEYBALL],
    location: 'Santa Teresa, Rio de Janeiro',
    distance: 4800,
    rating: 4.3,
    address: 'Rua Almirante Alexandrino, 660 - Santa Teresa, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9214, longitude: -43.1881 }
  },
  {
    id: '20',
    name: 'Quadras do Humaitá',
    coverImage: 'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?w=800&h=500&fit=crop',
    modalities: [GameModality.TENNIS, GameModality.BEACH_TENNIS],
    location: 'Humaitá, Rio de Janeiro',
    distance: 2200,
    rating: 4.5,
    address: 'Rua Voluntários da Pátria, 445 - Humaitá, Rio de Janeiro - RJ',
    coordinate: { latitude: -22.9542, longitude: -43.1958 }
  }
]

// Filtrar arenas por modalidade
export function filterArenasByModality(arenas: Arena[], modality: GameModality): Arena[] {
  return arenas.filter(arena => arena.modalities.includes(modality))
}

// Ordenar arenas por distância
export function sortArenasByDistance(arenas: Arena[]): Arena[] {
  return [...arenas].sort((a, b) => a.distance - b.distance)
}

// Helper para obter label das amenidades em português
export function getAmenityLabel(amenity: ArenaAmenity): string {
  const labels: Record<ArenaAmenity, string> = {
    [ArenaAmenity.PARKING]: 'Estacionamento',
    [ArenaAmenity.LOCKER_ROOM]: 'Vestiário',
    [ArenaAmenity.SHOWER]: 'Chuveiro',
    [ArenaAmenity.BATHROOM]: 'Banheiro',
    [ArenaAmenity.BAR]: 'Bar',
    [ArenaAmenity.RESTAURANT]: 'Restaurante',
    [ArenaAmenity.BBQ]: 'Churrasqueira',
    [ArenaAmenity.WIFI]: 'Wi-Fi',
    [ArenaAmenity.STORE]: 'Loja',
    [ArenaAmenity.LIGHTING]: 'Iluminação',
    [ArenaAmenity.AIR_CONDITIONING]: 'Ar Condicionado',
    [ArenaAmenity.BLEACHERS]: 'Arquibancada'
  }
  return labels[amenity]
}
